// 模拟数据：新闻、服务推荐、广告、合作伙伴等

export const banners = [
  { id: 1, img: 'https://picsum.photos/1200/450?random=1', link: 'https://www.baidu.com', alt: '广告1' },
  { id: 2, img: 'https://picsum.photos/1200/450?random=2', link: 'https://www.tencent.com', alt: '广告2' },
  { id: 3, img: 'https://picsum.photos/1200/450?random=3', link: 'https://www.alibaba.com', alt: '广告3' }
]

export const partners = [
  { id: 1, logo: 'https://picsum.photos/180/80?random=11', name: '合作方A', link: 'https://www.apple.com' },
  { id: 2, logo: 'https://picsum.photos/180/80?random=12', name: '合作方B', link: 'https://www.microsoft.com' },
  { id: 3, logo: 'https://picsum.photos/180/80?random=13', name: '合作方C', link: 'https://www.google.com' },
  { id: 4, logo: 'https://picsum.photos/180/80?random=14', name: '合作方D', link: 'https://www.huawei.com' },
  { id: 5, logo: 'https://picsum.photos/180/80?random=15', name: '合作方E', link: 'https://www.xiaomi.com' },
  { id: 6, logo: 'https://picsum.photos/180/80?random=16', name: '合作方F', link: 'https://www.lenovo.com' }
]

// 服务推荐列表（原产品展示）
export const services = [
  {
    id: 1,
    name: '企业协同办公服务',
    cover: 'https://picsum.photos/360/220?random=21',
    summary: '面向中大型企业的一体化办公解决方案，提升协作效率。'
  },
  {
    id: 2,
    name: '智能数据分析服务',
    cover: 'https://picsum.photos/360/220?random=22',
    summary: '帮助企业快速搭建可视化报表，驱动数据决策。'
  },
  {
    id: 3,
    name: '客户关系管理服务',
    cover: 'https://picsum.photos/360/220?random=23',
    summary: '覆盖销售线索、客户管理、售后服务的全流程 CRM 服务。'
  },
  {
    id: 4,
    name: '移动电商解决方案',
    cover: 'https://picsum.photos/360/220?random=24',
    summary: '支持多端一体，全渠道触达客户的电商服务。'
  }
]

export const newsList = [
  {
    id: 1,
    title: '数字化转型浪潮下，企业如何构建核心竞争力？',
    cover: 'https://picsum.photos/420/240?random=31',
    date: '2025-10-18',
    author: '企业研究院',
    summary: '在新一轮技术革命与产业变革背景下，数字化转型正在重塑企业的商业模式与运营体系……',
    content: `
      <p>在以云计算、大数据、人工智能为代表的新技术推动下，数字化转型已成为企业发展的必答题。</p>
      <p>企业需要从战略、组织、流程、技术多维度进行重构，构建以数据为核心的数字化能力。</p>
      <p>本篇文章将结合多个行业案例，拆解数字化转型的关键路径与落地方法。</p>
    `
  },
  {
    id: 2,
    title: '智能办公时代，如何打造高效协同的工作环境？',
    cover: 'https://picsum.photos/420/240?random=32',
    date: '2025-11-02',
    author: '产品中心',
    summary: '远程办公与混合办公形态日渐普及，企业如何通过数字工具提升协同效率？',
    content: `
      <p>智能办公的本质，是通过技术手段降低沟通成本、提高协同效率。</p>
      <p>从即时通讯、任务管理到知识库沉淀，系统化的平台是实现智能办公的基础设施。</p>
      <p>选择适合自身业务特点的解决方案，是每一家企业需要思考的问题。</p>
    `
  },
  {
    id: 3,
    title: '中小企业上云的最佳实践与避坑指南',
    cover: 'https://picsum.photos/420/240?random=33',
    date: '2025-11-15',
    author: '技术中心',
    summary: '上云已成为大势所趋，但如何少走弯路、用好云资源？',
    content: `
      <p>上云不只是简单的“上服务器”，而是一次系统工程。</p>
      <p>从业务评估、架构设计、安全合规到成本优化，每一步都至关重要。</p>
      <p>本文将梳理上云过程中的关键节点，并分享多个真实案例。</p>
    `
  }
]

